import { Dashboard } from "@/components/dashboard/Dashboard/Dashboard";
import { VStack } from "@/components/layout/VStack";
import { useEffect, useState } from "react";
import { useLoadDashboard } from "../hooks/dashboard/useLoadDashboard";
import { OpenSignups } from "../components/dashboard/OpenSignups/OpenSignups";
import { UpcomingExplorations } from "../components/dashboard/UpcomingExplorations/UpcomingExplorations";
import { Attendance } from "../components/dashboard/Attendance/Attendance";
import { SignUpSheet } from "../components/dashboard/OpenSignups/SignUpSheet";

const StudentDashboard = () => {
  const [open, setOpen] = useState<{
    open: boolean;
    data?: { rotation: any; session: any };
  }>({ open: false, data: undefined });
  const [openSignups, setOpenSignups] = useState<{
    sessions: any[];
    rotations: any[];
  }>({ rotations: [], sessions: [] });
  const [upcomingExplorations, setUpcomingExplorations] = useState<{
    explorations: any[];
    rotations: any[];
    sessions: any[];
    teachers: any[];
  }>({ explorations: [], rotations: [], sessions: [], teachers: [] });
  const [attendance, setAttendance] = useState<{
    total: { records: number; present: number };
    rotations: any[];
  } | null>(null);

  const { loadOpenSignups, loadUpcomingExplorations, loadAttendance, loading } =
    useLoadDashboard();

  useEffect(() => {
    loadOpenSignups(setOpenSignups);
    loadUpcomingExplorations(setUpcomingExplorations);
    loadAttendance(setAttendance);
  }, []);

  const onOpen = (rotationId: string, sessionId: string) => {
    const rotation = openSignups.rotations.find((r) => r._id === rotationId);
    const session = openSignups.sessions.find((s) => s._id === sessionId);
    setOpen({
      open: true,
      data: { rotation, session },
    });
  };

  return (
    <Dashboard activePage="/dashboard">
      <VStack>
        <h2
          style={{
            fontSize: "var(--text-2xl)",
            lineHeight: "var(--line-height-2xl)",
            fontWeight: "var(--font-bold)",
          }}
        >
          Student Dashboard
        </h2>
        <p style={{ color: "var(--muted-foreground)" }}>
          View sessions open for signup, your upcoming explorations, and your
          attendance stats.
        </p>
      </VStack>
      <OpenSignups
        data={openSignups}
        loading={loading.openSignups}
        onOpen={onOpen}
      />
      <UpcomingExplorations
        data={upcomingExplorations}
        loading={loading.upcomingExplorations}
      />
      <Attendance data={attendance} loading={loading.attendance} />
      {open.data?.rotation && open.data.session && (
        <SignUpSheet
          open={open.open}
          onOpenChange={(open) => {
            setOpen((prev) => ({
              ...prev,
              open,
            }));
          }}
          data={open.data}
          setOpenSignups={setOpenSignups}
        />
      )}
    </Dashboard>
  );
};

export default StudentDashboard;
